__webpack_require__.p = "https://gamma.addapt.fintech.amazon.dev/";